import { DaysType } from "../../enums/days-type.enum";
import { FrequencyType } from "../../enums/frequency-type.enum";
import { ScheduleOrderStatus } from "./schedule-order-status.model";

export class ScheduleOrder {
    scheduleName: string;
    scheduleId?: number;
    orderId?: string;
    startDate: string;
    endDate: string;
    runFrequency: number;
    frequencyType: FrequencyType;
    runConfig?: RunConfig;
    createdByName?: string;
    createdOn?: string;
    status?: ScheduleOrderStatus;
    runFrequencyDetail?: string;
    createdByUserId?: string;
}

export class RunConfig{
    selectedDays?: DaysType[];
    selectedDate?: number;
    selectedWeek?: number;
    selectedMonth?: number;
}